import { datadogRum } from '@datadog/browser-rum';

export class DatadogTrack {
  public static action = (name: string, properties?: object) => {
    datadogRum.addAction(name, properties);
  };

  public static error = (error: Error, context?: object) => {
    datadogRum.addError(error, context);
  };

  /**
   * Attaches a property to every subsequent RUM event (errors included).
   *
   * Used for route ownership: errors caught by a generic ErrorBoundary — such as the
   * one inside `<Page>` — have no idea which feature they belong to, so the owning team
   * has to be set globally when the route changes rather than at each `addError` call.
   * Without it a Datadog monitor cannot route the alert to `@team-<handle>`.
   *
   * Passing `undefined` removes the property, so a route without an owner does not
   * inherit the previous route's team.
   */
  public static setGlobalContextProperty = (key: string, value: unknown) => {
    if (value === undefined) {
      datadogRum.removeGlobalContextProperty(key);
      return;
    }
    datadogRum.setGlobalContextProperty(key, value);
  };

  public static addLoadingTiming = () => {
    datadogRum.addTiming('page_loading');
  };
}
